'use client';
import apiClient from './apiClient';

/** 會員相關 */
class AuthClient {
    // 取得 login user
    getUser = (locale) =>
        apiClient('/auth/user', {
            headers: {
                'X-LANG': 'zh-' + locale,
            },
        });

    // 登出
    logout = () => apiClient.post('/auth/logout');

    // email 登入
    emailSignin = (email) =>
        apiClient.post('/auth/signin/email/', {
            email,
        });

    verifyEmail = (email, verifyCode) =>
        apiClient.post('/auth/verify/email/', {
            email,
            verifyCode,
        });

    // email驗證
    // verifyMail = (mail) => apiClient.post('/auth/members/send-email-verification-code', mail);
}

const authClient = new AuthClient();

export default authClient;
